export default "__VITE_ASSET__BZPAMuD1__"